import { css, Global } from '@emotion/react';
import React from 'react';

export const colors = {
    blue: '#1883E7',
    navy: '#0E3347',
    black: '#26292B',
    gold: '#DFC74B',
    white: 'white',
    offWhite: '#EFEFEF',
};

const size = {
    mobileS: '320px',
    mobileM: '375px',
    mobileL: '400px',
    tablet: '768px',
    laptop: '1020px',
    laptopL: '1281px',
    desktop: '1580px',
    desktopL: '1820px',
};

export const device = {
    mobileS: `(min-width: ${size.mobileS})`,
    mobileM: `(min-width: ${size.mobileM})`,
    mobileL: `(min-width: ${size.mobileL})`,
    tablet: `(min-width: ${size.tablet})`,
    laptop: `(min-width: ${size.laptop})`,
    laptopL: `(min-width: ${size.laptopL})`,
    desktop: `(min-width: ${size.desktop})`,
    desktopL: `(min-width: ${size.desktopL})`,
};

export const GlobalStyles: React.FC = () => {
    return (
        <Global
            styles={css`
                html {
                    box-sizing: border-box;
                    font-size: 100%;
                    overflow-x: hidden;
                    -ms-text-size-adjust: 100%;
                    -webkit-text-size-adjust: 100%;
                    scroll-behavior: smooth;
                }

                body {
                    background: ${colors.offWhite};
                    font-weight: normal;
                    font-size: 1rem;
                    word-wrap: break-word;
                    font-kerning: normal;
                    overflow-x: hidden;
                    word-wrap: break-word;
                    margin: 0;
                    -webkit-font-smoothing: antialiased;
                }

                * {
                    font-family: 'Nunito Sans';
                    margin: 0;
                }
                .margin {
                    margin: 1em 0em;
                }
                .container {
                    max-width: 1200px;
                    margin: 0 auto;
                }
                .blue {
                    color: ${colors.blue};
                }
                .gold {
                    color: ${colors.gold};
                }
                .shadow {
                    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
                }
                h1,
                h2 {
                    font-size: 32px;
                    line-height: 44.8px;
                    font-weight: 900;
                    color: ${colors.navy};
                }
                h3 {
                    line-height: 44.8px;
                    color: ${colors.navy};
                    font-size: 32px;
                    font-weight: 900;
                }
                h4 {
                    color: ${colors.navy};
                    font-size: 36px;
                    line-height: 46.8px;
                    font-weight: 900;
                }
                p {
                    font-size: 18px;
                    line-height: 32.4px;
                    color: ${colors.black};
                }
                a {
                    text-decoration: none;
                }
                *,
                *:before,
                *:after {
                    box-sizing: border-box;
                }

                img {
                    max-width: 100%;
                    display: block;
                }
                ul {
                    padding-left: 0;
                }
                button,
                input,
                optgroup,
                select,
                textarea {
                    margin: 0;
                }
                button {
                    cursor: pointer;
                }
                button,
                input {
                }
                ::-webkit-input-placeholder {
                    color: inherit;
                    opacity: 0.54;
                }
                ::-webkit-file-upload-button {
                    -webkit-appearance: button;
                    font: inherit;
                }
                select:focus {
                    outline: 2.5px solid ${colors.blue}; /* oranges! yey */
                    /* border: none; */
                    border: none;
                    border-radius: 3px;
                }
                input[type='time']:focus {
                    outline: 2.5px solid ${colors.blue}; /* oranges! yey */
                    /* border: none; */
                    border: none;
                    border-radius: 3px;
                }
                input[type='text']:focus {
                    outline: 2.5px solid ${colors.blue}; /* oranges! yey */
                    /* border: none; */
                    border: none;
                    border-radius: 3px;
                }
                input[type='email']:focus {
                    outline: 2.5px solid ${colors.blue}; /* oranges! yey */
                    /* border: none; */
                    border: none;
                    border-radius: 3px;
                }
                input[type='tel']:focus {
                    outline: 2.5px solid ${colors.blue}; /* oranges! yey */
                    /* border: none; */
                    border: none;
                    border-radius: 3px;
                }
                input[type='date']:focus {
                    outline: 2.5px solid ${colors.blue}; /* oranges! yey */
                    /* border: none; */
                    border: none;
                    border-radius: 3px;
                }
                input[type='date']::-webkit-calendar-picker-indicator {
                    position: relative;
                    right: 0.6em;
                    fill: red;
                    top: 0.32em;
                    height: 30px;

                    -webkit-appearance: none;
                }

                textarea:focus {
                    outline: 2px solid ${colors.blue}; /* oranges! yey */
                    border: none;
                }

                @media ${device.mobileL} {
                }
                @media ${device.tablet} {
                    h1,
                    h2 {
                        font-size: 47px;
                        line-height: 74px;
                    }
                    h4 {
                        font-size: 60px;
                        line-height: 84px;
                        font-weight: 900;
                    }
                    .container {
                        max-width: 720px;
                        margin: 0 auto;
                    }
                }
                @media ${device.laptop} {
                    .container {
                        position: relative;
                        max-width: 920px;
                    }
                    .container {
                        max-width: 920px;
                    }
                }

                @media ${device.laptopL} {
                    h1,
                    h2 {
                        font-size: 60px;
                        line-height: 84px;
                    }
                    .container {
                        max-width: 1165px;
                        margin: 0 auto;
                    }
                }
                @media ${device.desktopL} {
                    .container {
                        max-width: 1265px;
                        margin: 0 auto;
                    }
                }
            `}
        />
    );
};
